module.exports = __webpack_public_path__ + "static/media/Screenshot 2021-03-28 134854.cc4c4b36.png";